// extracted by mini-css-extract-plugin
module.exports = {"chevron":"clamp-button_chevron__FqLW5","chevronButton":"clamp-button_chevronButton__xQt7w"};